export default __webpack_public_path__ + "static/media/icon-time.71196f59.svg";